module.exports = __webpack_public_path__ + "static/media/Billing-Illsutration.6c7eb144.png";